module.exports = __webpack_public_path__ + "img/greencircle.83b5ef8a.svg";